/* unplugin-vue-components disabled */import script from "./race-info.vue?vue&type=script&lang=jsx"
export * from "./race-info.vue?vue&type=script&lang=jsx"

import "./race-info.vue?vue&type=style&index=0&id=4a3e1538&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3e1538"]])

export default __exports__